import moment from 'moment-timezone';

class EditReservationController {

  constructor($window, $timeout, authenticateApi, basket, storeService, propertyService, configService, dateService, contentService, markdownService) {
    this.$window = $window;
    this.$timeout = $timeout;
    this.authenticateApi = authenticateApi;
    this.basket = basket;
    this.storeService = storeService;
    this.propertyService = propertyService;
    this.configService = configService;
    this.dateService = dateService;
    this.contentService = contentService;
    this.markdownService = markdownService;
  }

  $onInit () {
    this.displaySuccess();

    this.setCalendarMinDate();

    this.getContent();
  }

  editReservation () {
    this.error = null;

    if (this.reference && this.surname && this.date) {
      this.saving = true;

      return this.authenticateApi.byReference({
        reference: this.reference,
        surname: this.surname,
        date: this.date,
        basketCode: this.basket.contents.identity_code
      })
        .then(response => {
          this.storeService.set('reservation', response.reference);
          this.storeService.set('client_name', response.name);
          this.storeService.set('basket', response.basket);
          this.storeService.set('start_date', response.startDate);
          this.storeService.set('end_date', response.endDate);
          this.storeService.set('searchDate', response.startDate);
          this.displaySuccess();

          return this.basket.getApiBasket();
        })
        .catch((error) => {
          if (error
                        && error.data
                        && error.data.reason) {
            switch (error.data.reason) {
            case 'inPast':
              this.error = 'Sorry, you cannot edit this booking as the departure date has already passed.';
              break;
            case 'notFound':
              this.error = 'Sorry, we could not find that booking';
              break;
            default:
              this.error = 'Sorry, we could not authenticate you with those details';
              break;
            }

            return;
          }
          this.error = 'Sorry, we could not authenticate you with those details';
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  displaySuccess () {
    if (this.storeService.get('client_id')) {
      this.isLoggedIn = true;
      return false;
    }

    if (this.storeService.get('reservation')) {
      this.isEditing = true;
      return true;
    }

    this.isEditing = false;
    this.isLoggedIn = false;
  }

  setCalendarMinDate () {
    this.$timeout(() => {
      if (this.$window.fpInput
                && typeof this.$window.fpInput === 'object'
                && typeof this.$window.fpInput.set === 'function') {
        this.$window.fpInput.set('minDate', moment()
          .subtract(6, 'weeks')
          .format('YYYY-MM-DD'));
      }
    }, 1000);
  }

  displayName () {
    return this.storeService.get('client_name');
  }

  displayReference () {
    return this.basket.contents.reservation_reference;
  }

  displayDates () {
    return this.dateService.displayFromToDate(this.storeService.get('start_date'), this.storeService.get('end_date')) || '';
  }

  displayUrl (type) {
    switch (type) {
    case 'treatments':
      if (this.propertyService.get('listTreatments')) {
        return '/categories/treatments';
      }

      return '/treatments';
    case 'spadays':
      if (this.propertyService.get('listSpaDays')) {
        return '/categories/spa-days';
      }

      return '/spa-days';
    case 'activities':
      return '/activities';
    }
  }

  displayEventTypes () {
    let types = [];

    if (this.propertyService.get('hasTreatments')) {
      types.push('Treatments');
    }

    if (this.propertyService.get('hasSpaDays')) {
      types.push('Spa Days');
    }

    if (this.propertyService.get('hasActivities') && this.openActivities()) {
      types.push('Activities');
    }

    return types.join(' or ');
  }

  openActivities () {
    return this.propertyService.get('openActivities');
  }

  getContent () {
    return this.contentService.getContent('manage-booking')
      .then(response => {
        if (response && response.body) {
          this.content = response.body.text;
        }
      });
  }
}
EditReservationController.$inject = [ '$window', '$timeout', 'authenticateApi', 'basket', 'storeService', 'propertyService', 'configService', 'dateService', 'contentService', 'markdownService' ];

export default EditReservationController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/editReservation.controller.js